import { Dispatch, Action } from 'redux'
import { PaymentFailedMainMapDispatchReturnType } from './types/PaymentFailedMainMapDispatchReturnType'

export const PaymentFailedMainMapDispatch = (
  _dispatch: Dispatch<Action>
): PaymentFailedMainMapDispatchReturnType => {
  return {
  }
}
